<template>
  <v-container class="mt-4 px-0">
    <changable-core-board
      v-if="is_admin"
      :sub-title="board.subTitle"
      :icon="board.icon"
      :titleOverride="board.titleOverride"
    ></changable-core-board>
    <core-board
      v-else
      :user="user"
      :manager="manager"
      :company="company"
      :items="items"
      v-on:change="coreBoardId = $event"
      :sub-title="board.subTitle"
      :icon="board.icon"
      :titleOverride="board.titleOverride"
    ></core-board>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import ChangableCoreBoard from "@/components/corecard/ChangableCoreBoard";
import CoreBoard from "@/components/corecard/CoreBoard";
export default {
  name: "Dashboard",
  components: {
    ChangableCoreBoard,
    CoreBoard
  },
  data: () => ({
    coreBoardId: 3
  }),
  computed: {
    board() {
      switch (this.$vuetify.lang.current) {
        case "table_group":
          return {
            titleOverride: "Table Group Analytics",
            subTitle: "A collection of key metrics from The Table Group",
            icon: this.$images.TABLE_GROUP_DARK_ICON
          };
        default:
          return {
            titleOverride: this.is_admin ? null : "CoreBoard Report",
            subTitle: null,
            icon: null
          };
      }
    },
    user() {
      return this.coreBoardId == 1 ? this.profile : null;
    },
    manager() {
      return this.coreBoardId == 2 ? this.profile : null;
    },
    company() {
      return this.coreBoardId == 3 ? { name: this.profile.companyName } : null;
    },
    items() {
      let list = [{ id: 1, name: `${this.profile.firstName}'s CoreBoard` }];
      if (this.profile.isManager) {
        list.push({ id: 2, name: `Team CoreBoard` });
      }
      list.push({ id: 3, name: "Company CoreBoard" });
      return list;
    },
    ...mapGetters({
      profile: "profile/profile",
      is_admin: "profile/is_admin"
    })
  },

  methods: {}
};
</script>
